import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slideshare': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M187.7 153.7c34 0 61.7 25.7 61.7 57.7 0 31.7-27.7 57.7-61.7 57.7s-61.7-26-61.7-57.7c0-32 27.7-57.7 61.7-57.7zM331.1 153.7c34.3 0 61.8 25.7 61.7 57.7 0 31.7-27.4 57.7-61.7 57.7-34 0-61.7-26-61.7-57.7 0-32 27.7-57.7 61.7-57.7zM487.7 243.7c15.2-10.5 25.2 4 16.1 17.8-18.3 22.6-53.2 50.3-106.3 72 56.3 191.7-137.4 222.3-134.3 124 0-0.7-0.3-53.8-0.3-93.5-4.3-0.8-8.6-2-13.7-3.1 0 40-0.3 95.9-0.3 96.6 3.1 98.2-190.6 67.6-134.3-124.1-53.2-21.7-88-49.4-106.3-72-9.1-13.7 0.9-28.3 16-17.7 2 1.4 4.3 2.9 6.3 4.3v-198.3c0-27.4 20.6-49.7 46-49.7h359.1c25.4 0 46 22.3 46 49.7v198.3zM457.2 262.9h0.1v-190.6c0-32.8-10.6-45.7-40.9-45.7h-317.7c-31.7 0-40.6 10.8-40.6 45.7v192.4c67.7 35.4 125.7 29.1 157.4 28 13.4-0.3 22 2.3 27.1 7.7 1.7 1.6 10 9.4 20.3 17.1 1.1-15.8 10-25.8 33.7-24.9 32.3 1.4 91.7 7.7 160.6-29.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/slideshare.js
// module id = 1018
// module chunks = 0